export default {
  pageHeroV1: {
    container: {
      height: '100vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%,-50%)',
      h1: {
        fontSize: ['2.5rem', '', '4.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        borderColor: 'secondary',
        // backgroundColor: 'rgba(0,0,0,0.35)',
        padding: '1rem',
        fontFamily: 'heading',
        fontWeight: 'normal',
        color: 'white'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
